<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Color Chart</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="color-chart-main col-12 float-l">
                    <div class="row">
                        <p class="heading-text-20 line-height-24 color-098de1 font-text-regular-san"> Primary Colors </p>

                        <div class="color-platte-main width-full">
                            <div class="colo-platte-inner colpie-17 bg-color-098de1 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50">#098de1</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-154174 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50">#154174</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-c3202b border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50">#c3202b</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-607d8b border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50">#607d8b</p>
                            </div>

                            <div class="colo-platte-inner colpie-17  bg-color-999999 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50">#999999</p>
                            </div>
                        </div>

                        <p class="heading-text-20 line-height-24 font-text-regular-san color-9c1a22 mt-70"> Secondary Colors </p>

                        <div class="color-platte-main width-full">
                            <div class="colo-platte-inner colpie-17 bg-color-97cbed border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#97cbed</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-9badc1 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#9badc1</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-e1a0a4 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#e1a0a4</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-b9c5cb border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#b9c5cb</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-dddddd border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#dddddd</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-67b7e9 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#67b7e9</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-6f89a8 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#6f89a8</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-d7757c border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#d7757c</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-9cadb5 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#9cadb5</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-bebebe border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#bebebe</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-0771b4 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#0771b4</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-42658e border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#42658e</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-9c1a22 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#9c1a22</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-4d646f border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#4d646f</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-7a7a7a border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#7a7a7a</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-055587 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#055587</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-0d2746 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#0d2746</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-75131a border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#75131a</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-3a4b53 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#3a4b53</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-444444 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#444444</p>
                            </div>
                        </div> 

                        <p class="heading-text-20 line-height-24 font-text-regular-san color-71aa3f mt-70"> Other Colors </p>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-def1cc border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#def1cc</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-fceed6 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#fceed6</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-d2f3f8 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#d2f3f8</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-a6c888 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#a6c888</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-fbd28b border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#fbd28b</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-a9dfe5 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#a9dfe5</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-71aa3f border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#71aa3f</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-ffbb44 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#ffbb44</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-32a3b0 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#32a3b0</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-446626 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#446626</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-cc9636 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#cc9636</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-23727b border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#23727b</p>
                            </div>
                        </div>

                        <div class="color-platte-main width-full mt-8">
                            <div class="colo-platte-inner colpie-17 bg-color-2d4419 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#2d4419</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-997029 border-radius-5 mr-50 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#997029</p>
                            </div>

                            <div class="colo-platte-inner colpie-17 bg-color-195158 border-radius-5 float-l">
                                <p class="center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0">#195158</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--page content-->

        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Tooltip } from 'bootstrap-vue/es/components';
    import { Popover } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {

            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/colorchart.vue